import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {Observable} from 'rxjs';
import {ISendActionResponse} from '../interfaces/send-action-response.interface';

@Injectable({
    providedIn: 'root'
})
export class HttpService {
    private region = 'us-east-1';
    // b = bandwidth - shorter param name for GET URL
    private readonly allowedParams = ['preview', 'publish', 'dataUID', 'ignoreCache', 'fingerprint', 'sessionId', 'b'];

    constructor(private http: HttpClient) {}

    setRegion(region: string) {
        if (typeof environment.videoDeliveryApiUrl === 'object' && (environment.videoDeliveryApiUrl as object)[region]) {
            this.region = region;
        }

        return this.region;
    }

    getVideo(videoId: string, params: Map<string, string>) {
        const timezoneOffset = new Date().getTimezoneOffset();
        const uri = environment.performanceBuild
            ? this.getApiUrl(
                `/video/${videoId}/performance?timeZone=${timezoneOffset}${this.getUriFromParams(
                    params
                )}`
            )
            : this.getApiUrl(
                `/video/${videoId}?timeZone=${timezoneOffset}${this.getUriFromParams(
                    params
                )}`
            );

        return this.http.get(uri);
    }

    getInteractionHtml(assetUrl: string) {
        if (!assetUrl
            .match('^https:\\/\\/assets(\\..*)?\\.engageone\\.video\\/.*\\/interactions\\/interaction.html')
        ) {
            throw new Error('Forbidden interaction asset url');
        }

        return this.http.get(assetUrl, {
            responseType: 'text'
        });
    }

    storeEvent(jsonString: string) {
        const uri = this.getApiUrl(`/video/event`);

        this.http.post(uri, jsonString, {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            }
        }).subscribe();
    }

    sendAction(sessionId: string, actionId: string): Observable<ISendActionResponse> {
        const uri = this.getApiUrl(`/session/${sessionId}/action/${actionId}`);

        return this.http.post<ISendActionResponse>(uri, undefined);
    }

    session(videoId: string, name?: string, jsonString?: string) {
        let uri = this.getApiUrl(`/video/${videoId}/session`);

        if (name) {
            uri += `/${name}`;
        }

        if (environment.performanceBuild) {
            uri += '/performance';
        }

        return this.http.put<{ data: Map<string, any>; sessionToken: string }>(uri, jsonString);
    }

    private getApiUrl(path) {
        const base = typeof environment.videoDeliveryApiUrl === 'string'
            ? environment.videoDeliveryApiUrl
            : environment.videoDeliveryApiUrl[this.region];

        return base + path;
    }

    private getUriFromParams(params: Map<string, string>) {
        let uri = '';

        if (params) {
            uri = Array.from(params.keys()).reduce((paramUri, nextKey) => {
                if (this.allowedParams.includes(nextKey)) {
                    paramUri += `&${nextKey}=${params.get(nextKey)}`;
                }

                return paramUri;
            }, '');
        }
        return uri;
    }
}
